import { AffiliateCreateQuoteProps } from '@commenda/types/src/quotes/types';
import { fetcher } from '@commenda/utils';

export async function createQuote(
  // Affiliate firm to create a quote for:
  affiliateFirmId: string,
  data: AffiliateCreateQuoteProps
): Promise<Response | null> {
  try {
    const res = await fetcher(`affiliate-firms/${affiliateFirmId}/quotes`, {
      method: 'POST',
      body: {
        ...data,
      },
    });

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
